<ng-template #cpuInput>
  <mat-card>
    @if (formData.label?.length > 0) {
      <mat-card-title>{{ formData.label }} {{ formData.isRequired ? '*' : '' }}</mat-card-title>
    }
    <mat-card-content>
      <mat-radio-group
        [attr.aria-label]="formData.label"
        [attr.name]="groupName()"
        [formControl]="formGroup.controls[formName]"
        [required]="formData.isRequired">
        @for (item of formData.items; track $index) {
          <mat-radio-button [checked]="item.checked"
                            [class]="item.invalid?'invalid':''"
                            [disabled]="item.disabled"
                            [value]="item.value">
            {{ item.label }}
          </mat-radio-button>
        }
      </mat-radio-group>
    </mat-card-content>
    <app-error [formGroup]="formGroup" [formName]="formName"></app-error>
  </mat-card>
</ng-template>

<app-base [childContext]="ctx" [componentsTemplate]="cpuInput"></app-base>
